module.exports = __webpack_public_path__ + "img/yishi22.fbfd4d99.jpg";